import React from 'react'
import { useSelector } from 'react-redux'

const FormDashboardInputPassword = ({className, defaultValue, ...props}) => {
  const translation = useSelector(state => state.translation.data)
  const language = useSelector(state => state.system.language)
  const [show, setShow] = React.useState(false)
  const label = show ? translation.AUTH.hide[language.name] : translation.AUTH.show[language.name]

  return (
    <div className="relative">
      <input
        type={show ? 'text' : 'password'}
        className={`rounded border py-2 px-4 text-sm ${className}`}
        style={{borderColor: '#ddd'}}
        defaultValue={defaultValue}
        {...props}
      />
      <div className={`cursor-pointer text-sm absolute right-0 top-0 h-full pr-4 flex items-center`} onClick={() => setShow(!show)}>
        {label}
      </div>
    </div>
  )
}

export { FormDashboardInputPassword }
